// extracted by mini-css-extract-plugin
export default {"root":"TabArrow_root__uk11u","prev":"TabArrow_prev__TaXf3","next":"TabArrow_next__cJlZG"};